import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/',
    redirect: () => (store.getters['auth/isLoggedIn'] ? '/dashboard' : '/login')
  },
  {
    path: '/',
    component: () => import('@/components/Layout/index.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/Dashboard/index.vue'), meta: { title: '首页' } },
      { path: 'health', redirect: '/health/workbench' },
      {
        path: 'health/workbench',
        name: 'HealthWorkbench',
        component: () => import('@/views/Health/HealthWorkbench.vue'),
        meta: { title: '健康数据工作台', auraIosShell: true }
      },
      { path: 'health/blood-pressure', redirect: '/health/workbench' },
      { path: 'health/blood-glucose', redirect: '/health/workbench' },
      { path: 'health/blood-lipid', redirect: '/health/workbench' },
      { path: 'health/blood-oxygen', redirect: '/health/workbench' },
      { path: 'health/bmi', redirect: '/health/workbench' },
      { path: 'health/sleep', redirect: '/health/workbench' },
      { path: 'health/exercise', redirect: '/health/workbench' },
      { path: 'health/condition', redirect: '/health/workbench' },
      { path: 'health/medication', redirect: '/health/workbench' },
      { path: 'health/kidney', redirect: '/health/workbench' },
      { path: 'health/liver', redirect: '/health/workbench' },
      { path: 'health/blood-routine', redirect: '/health/workbench' },
      { path: 'health/heart-rate', redirect: '/health/workbench' },
      { path: 'health/screening', redirect: '/health/workbench' },
      { path: 'patient/list', name: 'PatientList', component: () => import('@/views/Patient/index.vue'), meta: { title: '患者列表', auraIosShell: true } },
      { path: 'patient/detail/:id', redirect: (to) => ({ path: '/health/workbench', query: { patientId: to.params.id } }) },
      { path: 'patient/health/:id', redirect: (to) => ({ path: '/health/workbench', query: { patientId: to.params.id } }) },
      { path: 'patient/tag-group', name: 'TagGroup', component: () => import('@/views/Patient/TagGroup.vue'), meta: { title: '分组标签', auraIosShell: true } },
      { path: 'patient/family-members', name: 'PatientFamilyMember', component: () => import('@/views/Patient/FamilyMember.vue'), meta: { title: '家庭管理', auraIosShell: true } },
      {
        path: 'followup/workbench',
        name: 'FollowupWorkbench',
        component: () => import('@/views/Followup/FollowupWorkbench.vue'),
        meta: { title: '随访工作台', auraIosShell: true }
      },
      { path: 'followup/plan-template', redirect: '/followup/workbench' },
      { path: 'followup/plan-assignment', redirect: '/followup/workbench' },
      { path: 'followup/task', redirect: '/followup/workbench' },
      { path: 'followup/subscribe-log', name: 'FollowupSubscribeLog', component: () => import('@/views/Followup/SubscribeLog.vue'), meta: { title: '订阅发送日志' } },
      { path: 'doctor/list', name: 'DoctorList', component: () => import('@/views/Doctor/index.vue'), meta: { title: '医生列表', auraIosShell: true } },
      { path: 'doctor/org-account', name: 'OrgAccount', component: () => import('@/views/Doctor/OrgAccount.vue'), meta: { title: '组织账号', auraIosShell: true } },
      { path: 'doctor/hospital', name: 'HospitalList', component: () => import('@/views/Doctor/OrgAccount.vue'), meta: { title: '组织账号', auraIosShell: true } },
      { path: 'doctor/commission', name: 'CommissionList', component: () => import('@/views/Doctor/OrgAccount.vue'), meta: { title: '组织账号', auraIosShell: true } },
      { path: 'doctor/clinic-room', name: 'ClinicRoomConfig', component: () => import('@/views/System/ClinicRoom.vue'), meta: { title: '我的诊室配置' } },
      { path: 'message/list', name: 'MessageList', component: () => import('@/views/Message/index.vue'), meta: { title: '问诊记录', auraIosShell: true } },
      { path: 'assess/category', name: 'AssessCategory', component: () => import('@/views/Assess/Category.vue'), meta: { title: '服务分类' } },
      { path: 'assess/service-list', name: 'AssessServiceList', component: () => import('@/views/Assess/ServiceList.vue'), meta: { title: '服务列表' } },
      { path: 'assess/list', name: 'AssessList', component: () => import('@/views/Assess/index.vue'), meta: { title: '服务包管理' } },
      { path: 'assess/order', name: 'OrderList', component: () => import('@/views/Assess/Order.vue'), meta: { title: '订单管理' } },
      { path: 'assess/benefit', redirect: '/assess/order' },
      { path: 'assess/benefit-verify', name: 'BenefitVerify', component: () => import('@/views/Assess/BenefitVerify.vue'), meta: { title: '权益核销' } },
      { path: 'assess/shipment', name: 'ShipmentList', component: () => import('@/views/Assess/Shipment.vue'), meta: { title: '发货管理' } },
      { path: 'assess/inventory', name: 'InventorySupply', component: () => import('@/views/Assess/InventorySupply.vue'), meta: { title: '库存供应' } },
      { path: 'assess/doctor-wallet', name: 'DoctorWallet', component: () => import('@/views/Assess/DoctorWallet.vue'), meta: { title: '医生钱包' } },
      { path: 'assess/ops-board', name: 'OpsBoard', component: () => import('@/views/Assess/OpsBoard.vue'), meta: { title: '运营看板' } },
      { path: 'assess/refund', name: 'RefundList', component: () => import('@/views/Assess/Refund.vue'), meta: { title: '退款管理' } },
      { path: 'assess/refund-restock', name: 'RefundRestock', component: () => import('@/views/Assess/RefundRestock.vue'), meta: { title: '退款库存回补' } },
      { path: 'assess/order-config', redirect: '/assess/order' },
      { path: 'cost/wallet-list', redirect: '/assess/doctor-wallet' },
      { path: 'cost/wallet', redirect: '/assess/doctor-wallet' },
      { path: 'cost/consult-fee', redirect: '/assess/doctor-wallet' },
      { path: 'cost/product-inventory', redirect: { path: '/assess/inventory', query: { tab: 'stock' } } },
      { path: 'cost/supplier', redirect: { path: '/assess/inventory', query: { tab: 'supplier' } } },
      { path: 'cost/exam/fee-config', redirect: '/dashboard' },
      { path: 'cost/exam/pay-management', redirect: '/dashboard' },
      { path: 'cost/exam/accounts', redirect: '/dashboard' },
      { path: 'cost/exam', redirect: '/dashboard' },
      { path: 'cost', redirect: '/dashboard' },
      { path: 'points/rule', name: 'PointsRule', component: () => import('@/views/Points/Rule.vue'), meta: { title: '积分规则配置' } },
      { path: 'points/title', name: 'PointsTitle', component: () => import('@/views/Points/Title.vue'), meta: { title: '称号管理' } },
      { path: 'points/goods', name: 'PointsGoods', component: () => import('@/views/Points/Goods.vue'), meta: { title: '兑换商品管理' } },
      { path: 'points/exchange-order', name: 'PointsExchangeOrder', component: () => import('@/views/Points/ExchangeOrder.vue'), meta: { title: '兑换订单' } },
      { path: 'points/transaction', name: 'PointsTransaction', component: () => import('@/views/Points/Transaction.vue'), meta: { title: '积分流水' } },
      { path: 'ckm/xiaokang', name: 'XiaokangControl', component: () => import('@/views/CkmPlatform/XiaokangControl.vue'), meta: { title: '总控台' } },
      { path: 'ckm/health-chat-usage', name: 'HealthChatUsage', component: () => import('@/views/CkmPlatform/HealthChatUsage.vue'), meta: { title: 'AI_chat技能池用量', auraIosShell: true } },
      { path: 'ckm/hermes-library', redirect: '/ckm/aura-library' },
      { path: 'ckm/aura-library', name: 'AuraLibrary', component: () => import('@/views/CkmPlatform/AuraLibrary.vue'), meta: { title: '藏经阁', auraIosShell: true } },
      { path: 'ckm/xiaokang/design/:roleKey', name: 'AuraDutyDesignPage', component: () => import('@/views/CkmPlatform/AuraDutyDesignPage.vue'), meta: { title: '技能台', auraIosShell: true } },
      { path: 'report/ecg', name: 'ReportEcgBiz', component: () => import('@/views/Report/EcgBiz.vue'), meta: { title: '心电业务' } },
      { path: 'report/home-iot', name: 'ReportHomeIotBoard', component: () => import('@/views/Report/HomeIotBoard.vue'), meta: { title: '两院一体居家物联' } },
      { path: 'report/dashboard', redirect: '/report/ecg' },
      { path: 'report/health', redirect: '/report/ecg' },
      { path: 'report/followup', redirect: '/report/ecg' },
      { path: 'report/data-quality', redirect: '/report/ecg' },
      { path: 'report/sales', redirect: '/report/ecg' },
      { path: 'report/order', redirect: '/report/ecg' },
      { path: 'device/vendors', name: 'DeviceVendors', component: () => import('@/views/DeviceManagement/Vendors.vue'), meta: { title: '设备管理-厂商管理' } },
      { path: 'device/bindings', name: 'DeviceBindings', component: () => import('@/views/DeviceManagement/Bindings.vue'), meta: { title: '设备管理-设备总览', auraIosShell: true } },
      { path: 'system/user-company', name: 'SystemUserCompany', component: () => import('@/views/System/UserCompany.vue'), meta: { title: '公司账号' } },
      { path: 'system/role', name: 'SystemRole', component: () => import('@/views/System/Role.vue'), meta: { title: '角色权限' } },
      { path: 'system/about-us', name: 'AboutUs', component: () => import('@/views/System/AboutUs.vue'), meta: { title: '关于我们' } },
      { path: 'system/aura-user-app-release', name: 'AuraUserAppRelease', component: () => import('@/views/System/AuraUserAppRelease.vue'), meta: { title: 'APP更新', auraIosShell: true } },
      { path: 'system/clinic-room', redirect: '/doctor/clinic-room' },
      { path: 'system/version/app', name: 'VersionControlApp', component: () => import('@/views/System/VersionControl.vue'), meta: { title: '版本控制-APP' } },
      { path: 'system/version/miniprogram', name: 'VersionControlMiniProgram', component: () => import('@/views/System/VersionControl.vue'), meta: { title: '版本控制-小程序' } },
      { path: 'system/version/admin', name: 'VersionControlAdmin', component: () => import('@/views/System/VersionControl.vue'), meta: { title: '版本控制-后台' } },
      { path: 'system/log', name: 'SystemLog', component: () => import('@/views/System/Log.vue'), meta: { title: '操作日志' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 避免重复导航到当前路由时报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 心阅智康` : '心阅智康'
  if (to.meta.noAuth) {
    next()
    return
  }
  const needAuth = to.matched.some((r) => r.meta && r.meta.requiresAuth)
  if (needAuth && !store.getters['auth/isLoggedIn']) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  if (needAuth && to.path !== '/dashboard' && to.path !== '/login') {
    await store.dispatch('auth/fetchPermission')
    const perm = store.state.auth.permission
    const menus = perm?.menus
    if (Array.isArray(menus)) {
      if (menus.length === 0) {
        if (to.path !== '/dashboard' && to.path !== '/login') {
          next({ path: '/dashboard' })
          return
        }
      } else {
        const pathOk = (p) =>
          menus.some(m => p === m || (m !== '/' && p.startsWith(m + '/')))
        const hasLegacyFollowup =
          pathOk('/followup/plan-template') ||
          pathOk('/followup/plan-assignment') ||
          pathOk('/followup/task')
        const allowed =
          pathOk(to.path) ||
          (to.path === '/followup/workbench' && hasLegacyFollowup) ||
          (to.path === '/doctor/clinic-room' && pathOk('/system/clinic-room')) ||
          (to.path === '/doctor/org-account' && (pathOk('/doctor/hospital') || pathOk('/doctor/commission'))) ||
          (to.path === '/ckm/aura-library' || to.path === '/ckm/aura-library' && pathOk('/ckm/xiaokang'))
        if (!allowed) {
          next({ path: '/dashboard' })
          return
        }
      }
    }
  }
  next()
})

router.afterEach((to) => {
  if (typeof document === 'undefined') return
  document.body.classList.remove('duty-ios-shell')
  if (to.meta && to.meta.auraIosShell) {
    document.body.classList.add('aura-ios-shell')
  } else {
    document.body.classList.remove('aura-ios-shell')
  }
})

export default router
